import { EventBus } from '@vtblife/event-bus';
import { createDependencyValidator } from '@vtblife/form-renderer-kit/dist/components/form-renderer/utils/create-dependency-validator';
import { navigate } from '../../../utils/navigate';
import { QuizActionType } from '../../../types';
const eventBus = EventBus.getInstance();
export function execPostSubmitAction({ formData, postSubmitAction, setResultPage, }) {
    var _a;
    const action = postSubmitAction.find((action) => {
        const validator = createDependencyValidator(action.condition);
        if (validator) {
            return validator(formData);
        }
        return true;
    });
    if (!(action === null || action === void 0 ? void 0 : action.actionType)) {
        return;
    }
    if (action.actionType === QuizActionType.resultPage && action.resultPage) {
        setResultPage(action.resultPage);
    }
    else if (action.actionType === QuizActionType.redirect && action.redirect) {
        navigate(action.redirect);
    }
    else if (action.actionType === QuizActionType.auth) {
        eventBus.publish({
            category: 'simple',
            type: 'auth:initialize',
            data: action.auth,
        });
    }
    else if (action.actionType === QuizActionType.customEvent && ((_a = action.customEvent) === null || _a === void 0 ? void 0 : _a.eventType)) {
        eventBus.publish({
            category: 'simple',
            type: action.customEvent.eventType,
            data: action.customEvent.eventData,
        });
    }
}
//# sourceMappingURL=exec-post-submit-action.js.map